import React from "react";
import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";
import { timeline } from "../mock";

export default function Timeline() {
  useReveal();
  if (!timeline) return null;

  return (
    <section id="timeline" className="bg-ink2 border-b border-[var(--c-border)] py-20 sm:py-28" data-testid="timeline-section">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="eyebrow" data-testid="timeline-eyebrow">{timeline.eyebrow}</span>
          <h2 className="font-display text-3xl sm:text-5xl font-light text-parchment mt-4 leading-tight">
            {timeline.title}
          </h2>
          <p className="mt-5 text-lg text-parchment/60 font-light leading-relaxed">{timeline.intro}</p>
        </div>

        <div className="relative mt-14">
          <div className="hidden sm:block absolute top-14 left-0 right-0 h-px bg-gold/30" />
          <div className="flex gap-8 sm:gap-4 overflow-x-auto pb-4 sm:justify-between snap-x">
            {timeline.entries.map((e, i) => (
              e.fan ? (
                <div
                  key={i}
                  data-testid={`timeline-entry-${i}`}
                  className="reveal shrink-0 w-44 sm:w-56 flex flex-col items-center text-center snap-start"
                  style={{ animationDelay: `${i * 80}ms` }}
                >
                  <div className="relative w-44 sm:w-56 h-24 sm:h-28 z-10">
                    {e.faces.map((f, idx) => {
                      const pos = ["left-0 -rotate-6", "left-1/2 -translate-x-1/2 z-20", "right-0 rotate-6"][idx];
                      return (
                        <Link
                          key={f.id}
                          to={`/notable#kin-${f.id}`}
                          data-testid={`timeline-fan-${f.id}`}
                          title={`${f.name} — read their story`}
                          className={`group/face absolute top-0 ${pos} transition-all duration-300 hover:z-30`}
                        >
                          <div className="w-14 h-24 sm:w-16 sm:h-28 rounded-2xl overflow-hidden border-2 border-gold/50 bg-ink grayscale-[0.15] shadow-lg transition-all duration-300 group-hover/face:grayscale-0 group-hover/face:border-gold group-hover/face:scale-[1.35]">
                            <img src={f.img} alt={f.name} className="w-full h-full object-cover object-top" />
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                  <span className="mt-4 font-label text-[0.56rem] uppercase tracking-[0.16em] text-gold">{e.year}</span>
                  <span className="mt-1 font-display italic text-lg text-parchment/90">{e.name}</span>
                </div>
              ) : (
                <Link
                  key={i}
                  to={`/notable#kin-${e.id}`}
                  data-testid={`timeline-entry-${i}`}
                  title={`${e.name} — read their story`}
                  className="group reveal shrink-0 w-24 sm:w-auto sm:flex-1 flex flex-col items-center text-center snap-start cursor-pointer"
                  style={{ animationDelay: `${i * 80}ms` }}
                >
                  <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden border-2 border-gold/50 bg-ink relative z-10 grayscale-[0.15] transition-all duration-300 group-hover:grayscale-0 group-hover:border-gold group-hover:scale-105">
                    <img src={e.img} alt={e.name} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110" />
                  </div>
                  <span className="mt-4 font-label text-[0.56rem] uppercase tracking-[0.16em] text-gold">{e.year}</span>
                  <span className="mt-1 font-display italic text-lg text-parchment/90 group-hover:text-gold transition-colors duration-300">{e.name}</span>
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
